module.exports = __webpack_public_path__ + "img/searchicon.dd5869ec.png";